module.exports = __webpack_public_path__ + "img/hero-daddy-events.08cdd9ea.png";